<template>
  <b-modal
    id="modal-filter-live-streaming"
    size="md"
    modal-class="modal-filter mc-videohistory__modal-filter-trackvision"
    hide-header-close
    scrollable
  >
    <template #modal-header>
      <h5 class="modal-title">{{ $t('global.title.filterFleet') }}</h5>
      <span class="modal-reset-btn" @click="handleReset">{{ $t('global.resetAsset') }}</span>
    </template>
    <div class="mc-modal__filter-item">
      <FormulateInput type="group" name="videoStatus" label="Status Video">
        <div class="mc-modal__filter-button-group">
          <button
            type="button"
            :class="{ 'mc-modal__filter-button--active': filterModel.videoStatus.online }"
            class="mc-modal__filter-button"
            @click="handleClickFilterVideoStatus('online')"
          >
            {{ 'Video Online' }}
          </button>
          <button
            type="button"
            :class="{ 'mc-modal__filter-button--active': filterModel.videoStatus.offline }"
            class="mc-modal__filter-button"
            @click="handleClickFilterVideoStatus('offline')"
          >
            {{ 'Video Offline' }}
          </button>
        </div>
      </FormulateInput>
    </div>
    <div class="mc-modal__filter-item">
      <FormulateInput
        type="group"
        name="motionStatus"
        :label="$t('trackVideo.legend.motionStatus')"
      >
        <div class="mc-modal__filter-button-group">
          <button
            type="button"
            :class="{ 'mc-modal__filter-button--active': filterModel.motionStatus.moving }"
            class="mc-modal__filter-button"
            @click="handleClickFilterMotionStatus('moving')"
          >
            {{ $t('global.filter.running') }}
          </button>
          <button
            type="button"
            :class="{ 'mc-modal__filter-button--active': filterModel.motionStatus.idle }"
            class="mc-modal__filter-button"
            @click="handleClickFilterMotionStatus('idle')"
          >
            {{ $t('global.filter.idle') }}
          </button>
          <button
            type="button"
            :class="{ 'mc-modal__filter-button--active': filterModel.motionStatus.parking }"
            class="mc-modal__filter-button"
            @click="handleClickFilterMotionStatus('parking')"
          >
            {{ $t('global.filter.parking') }}
          </button>
          <button
            type="button"
            :class="{ 'mc-modal__filter-button--active': filterModel.motionStatus.offline }"
            class="mc-modal__filter-button"
            @click="handleClickFilterMotionStatus('offline')"
          >
            {{ $t('global.filter.offline') }}
          </button>
          <button
            v-if="hasAccess(['assisted_motion_status:read'])"
            type="button"
            :class="{ 'mc-modal__filter-button--active': filterModel.motionStatus.assisted }"
            class="mc-modal__filter-button"
            @click="handleClickFilterMotionStatus('assisted')"
          >
            {{ $t('liveView.filter.assisted') }}
          </button>
        </div>
      </FormulateInput>
    </div>
    <div class="mc-modal__filter-item">
      <FormulateInput
        v-bind="vehicleFields"
        :fullObject="fullObject['vehicleId']"
        :value="fullObject.vehicleId.map((item) => item.id)"
        @update:fullObject="
          ($event) => {
            fullObject.vehicleId = $event
          }
        "
      />
    </div>

    <template #modal-footer="{ cancel }">
      <b-row class="modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="modal__filter-footer-btn">
          <McButton
            variant="secondary"
            class="me-2"
            :text="$t('global.action.cancel')"
            @click="cancel"
          />
          <McButton variant="primary" :text="$t('global.action.apply')" @click="handleAccept" />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import { Helper } from '@/mixin/helper'

import { mapGetters } from 'vuex'

export default {
  name: 'ModalFilterLiveStreaming',
  components: {
    McButton,
  },
  mixins: [Helper],
  data() {
    const filterLiveStream = JSON.parse(window.localStorage.getItem('filter-live-stream-v2'))
    const videoStatus = {
      online: false,
      offline: false,
    }
    const motionStatus = {
      moving: false,
      idle: false,
      parking: false,
      offline: false,
      assisted: false,
    }
    let filterVehicleId = []

    if (filterLiveStream?.motionStatus.length) {
      filterLiveStream.motionStatus.forEach((val) => {
        motionStatus[val] = true
      })
    }
    if (filterLiveStream?.videoStatus.length) {
      filterLiveStream.videoStatus.forEach((val) => {
        videoStatus[val] = true
      })
    }
    if (filterLiveStream?.vehicleId.length) {
      filterLiveStream.vehicleId.forEach((val) => {
        filterVehicleId.push(val)
      })
    }

    return {
      filterModel: {
        videoStatus,
        motionStatus,
      },
      fullObject: {
        vehicleId: filterVehicleId,
      },
    }
  },
  computed: {
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      hasAccess: 'identity/hasAccess',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),
    vehicleFields() {
      const tableFields = [
        {
          label: this.$t('report.fields.licensePlate'),
          key: 'licensePlate',
          isSortable: true,
        },
        {
          label: this.$t('report.fields.fleetType'),
          key: 'vehicleType',
          isSortable: false,
          formatter: (value) => {
            return (
              (value.manufacturer ?? '-') +
              ' / ' +
              (value.model ?? '-') +
              ' / ' +
              (value.type ?? '-')
            )
          },
        },
        {
          label: this.$t('report.fields.vehicleGroup'),
          key: 'vehicle2Vgroup',
          isSortable: false,
          formatter: (value) => {
            return value && value.length > 0 ? value.map((v) => v.vgroup.name).join(', ') : '-'
          },
        },
      ]
      return {
        name: 'license-plate-filter-live-streaming',
        isShow: true,
        label: this.$t('report.fields.licensePlate'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.licensePlate')}`,
        trackBy: 'id',
        displayedBy: 'licensePlate',
        listGetter: (filter) => this.getVehicleList(filter),
        multiple: true,
        tableFields: tableFields,
        filters: [
          {
            label: this.$t('report.fields.fleetType'),
            key: 'vehicleType',
            data: this.$store.state.video.vehicleTypeList.length
              ? this.$store.state.video.vehicleTypeList.map(
                  ({ vehicleTypeId, manufacturer, model, type }) => ({
                    name: (manufacturer ?? '-') + ' / ' + (model ?? '-') + ' / ' + (type ?? '-'),
                    id: vehicleTypeId,
                  })
                )
              : [],
            model: [],
          },
          {
            label: this.$t('report.fields.vehicleGroup'),
            key: 'vgroup',
            data: this.$store.state.video.vgroupsList.length
              ? this.$store.state.video.vgroupsList.map(({ vgroupId, vgroup: { name } }) => ({
                  id: vgroupId,
                  name,
                }))
              : [],
            model: [],
          },
        ],
      }
    },
  },
  methods: {
    async getVehicleList(opt) {
      const { orderBy, search, vehicleType, vgroup } = opt

      const allVehicles = []
      this.$store.state.video.fleets.forEach((data) => {
        const groups = data.vehicle.vehicle2Vgroup
        allVehicles.push({
          licensePlate: data.parent
            ? data.parent?.vehicle?.licensePlate
            : data.vehicle.licensePlate,
          vehicle2Vgroup: groups,
          vehicleType: data.vehicle.vehicleType,
          id: data.vehicleId,
        })
      })

      let result = [...allVehicles]

      // apply filter
      result = result.filter((v) => {
        if (!vehicleType || vehicleType.length === 0) return true
        return vehicleType?.includes(v.vehicleType.vehicleTypeId)
      })
      result = result.filter((v) => {
        if (!vgroup || vgroup.length === 0) return true
        return v.vehicle2Vgroup.some((vg) => vgroup.includes(vg.vgroupId))
      })

      // apply search
      if (search) {
        result = result.filter((v) => {
          return this.isContains(search, v.licensePlate)
        })
      }

      result.sort((a, b) => {
        return a.licensePlate.toLowerCase().localeCompare(b.licensePlate.toLowerCase())
      })

      return {
        data: result,
        ids: result.map((data) => data.id), // ids vehicle
        pagination: {
          page: 1,
          show: result.length,
          total: result.length,
        },
      }
    },
    handleAccept() {
      let motionStatus = []
      let videoStatus = []
      let vehicleId = []

      Object.entries(this.filterModel.videoStatus).forEach(([key, value]) => {
        if (value) {
          videoStatus.push(key)
        }
      })

      Object.entries(this.filterModel.motionStatus).forEach(([key, value]) => {
        if (value) {
          motionStatus.push(key)
        }
      })

      if (this.fullObject.vehicleId.length > 0) {
        this.fullObject.vehicleId.forEach((item) => {
          vehicleId.push(item.id)
        })
      }

      const filterActive = {
        motionStatus,
        videoStatus,
        vehicleId,
      }

      this.$emit('acceptFilter', filterActive)

      this.$bvModal.hide('modal-filter-live-streaming')

      // set filter to localStorage
      this.setFilterToLocalStorage()
    },
    setFilterToLocalStorage() {
      const _motionStatus = []
      Object.entries(this.filterModel.motionStatus).forEach(([key, val]) => {
        if (val) {
          _motionStatus.push(key)
        }
      })
      const _videoStatus = []
      Object.entries(this.filterModel.videoStatus).forEach(([key, val]) => {
        if (val) {
          _videoStatus.push(key)
        }
      })
      const _vehicleId = this.fullObject.vehicleId
      const filterLiveStream = {
        motionStatus: _motionStatus,
        videoStatus: _videoStatus,
        vehicleId: _vehicleId,
      }
      window.localStorage.setItem('filter-live-stream-v2', JSON.stringify(filterLiveStream))
    },
    handleClickFilterVideoStatus(type) {
      this.filterModel.videoStatus[type] = !this.filterModel.videoStatus[type]
    },
    handleClickFilterMotionStatus(type) {
      this.filterModel.motionStatus[type] = !this.filterModel.motionStatus[type]
    },
    isContains(search, name) {
      const searchContains = RegExp(search ?? '', 'gi').exec(name ?? '')
      return searchContains != null && searchContains.length > 0
    },
    resetFilter() {
      this.filterModel.videoStatus.offline = false
      this.filterModel.videoStatus.online = false
      this.filterModel.motionStatus.assisted = false
      this.filterModel.motionStatus.idle = false
      this.filterModel.motionStatus.moving = false
      this.filterModel.motionStatus.offline = false
      this.filterModel.motionStatus.parking = false
      this.fullObject.vehicleId = []
    },
    async handleReset() {
      this.resetFilter()
      await this.delay(100) // wait for the reset to take effect
      this.handleAccept()
    },
  },
}
</script>
